import React from 'react';

export const LockboxContext = React.createContext({});

export const LockboxProvider = ({ children }) => {
  const [lockboxLoading, setLockboxLoading] = React.useState({});
  const [lockboxBalances, setLockboxBalances] = React.useState({});
  const [balanceRefreshInterval, setBalanceRefreshInterval] = React.useState(
    {},
  );
  const [initialContractsLoading, setInitialContractsLoading] =
    React.useState(false);
  const [contractDetailsLoading, setContractDetailsLoading] = React.useState(
    {},
  );
  const [contractDetails, setContractDetails] = React.useState({});
  const value = {
    lockboxBalances,
    setLockboxBalances,
    lockboxLoading,
    setLockboxLoading,
    contractDetails,
    setContractDetails,
    initialContractsLoading,
    setInitialContractsLoading,
    contractDetailsLoading,
    setContractDetailsLoading,
    balanceRefreshInterval,
    setBalanceRefreshInterval,
  };
  return (
    <LockboxContext.Provider value={value}>{children}</LockboxContext.Provider>
  );
};
